<template>
  <v-card>
    <v-card-title v-if="options.title">
      <span class="headline">{{ options.title }}</span>
    </v-card-title>
    <v-divider></v-divider>
    <v-card-text>
      <v-row>
        <v-col
          cols="12"
        >

        </v-col>
      </v-row>
      <ValidationObserver
        ref="form"
        tag="form"
        @submit.prevent="save"
      >
        <v-row>
          <v-col cols="12">
            <ValidationProvider
                rules="required"
                vid="name"
                :name="$t('fields.name').toLowerCase()"
                v-slot="{ errors }"
            >
              <v-text-field
                v-model=" form.name"
                :counter="30"
                :label="$t('fields.name')"
                :error-messages="errors"
              ></v-text-field>
            </ValidationProvider>
            <v-data-table
              :headers="headers"
              :items="items"
              v-model="selected"
              :single-select="false"
              item-key="id"
              show-select
              :server-items-length="totalItems"
              :no-data-text="$t('NO_DATA')"
              :no-results-text="$t('NO_DATA')"
              hide-default-footer
              :options.sync="pagination"
              :loading="loading"
              class="elevation-1"
            >
              <template v-slot:item.name="{ item }">
                <router-link :to="{ name: routeName.ROLE_SHOW, params: { id: item.id } }">
                    {{ item.name }}
                </router-link>
              </template>

            </v-data-table>
            <Paginator
              :total-items="totalItems"
              :page.sync="pagination.page"
              :items-per-page.sync="pagination.itemsPerPage"
              @change="fetchPermission"
            />

          </v-col>
        </v-row>
    </ValidationObserver>
    </v-card-text>
    <v-card-actions>
      <v-btn @click="save" color="primary">{{ $t('SAVE') }}</v-btn>
      <v-btn @click="cancel">{{ $t('CANCEL') }}</v-btn>
    </v-card-actions>
  </v-card>
</template>
<script>
  import { mapActions, mapState } from 'vuex';

  import { permissionsService } from '../../../utils/services/permissions.service';
  import { rolesService } from '../../../utils/services/roles.service';
  import Paginator from '../../shared/Paginator';

  export default {
    name: 'RoleModal',
    components: { Paginator },
    data() {
      return {
        stored: null,
        role: {},
        rolePermission: [],
        items: [],
        selected: [],
        totalItems: 0,
        pagination: {
          page: 1,
          itemsPerPage: 10,
          sortDesc: [false],
          sortBy: ['name'],
        },
        filters: {
          search: null,
        },
        headers: [
          {
            text: this.$t('fields.id'),
            align: 'left',
            value: 'id',
          },
          { text: this.$t('fields.name'), value: 'name' },
        ],
        form: {
          id: 0,
          permissions: [],
          name: null,
        },
        loading: false,
      };
    },
    computed: {
      ...mapState('modal', ['options', 'data']),
      requestFilters() {
        const filters = {
          search: this.filters.search,
        };
        if (this.pagination.sortBy.length === 1 && this.pagination.sortDesc.length === 1) {
          const { sortBy, sortDesc } = this.pagination;
          filters.sortBy = sortBy;
          filters.sortDesc = sortDesc;
        }
        return filters;
      },
    },

    methods: {
      ...mapActions('alert', ['showToast']),
      ...mapActions('modal', ['hideModal', 'loadingModal']),
      async save() {
        const isValid = await this.$refs.form.validate();
        if (isValid) {
            if (this.options.onSave) {
              this.loadingModal(true);
              const permissions = this.selected.map(x => x.name);
              // overwrite data
              this.form.permissions = permissions;
              this.options.onSave(
                this.form,
                this.errors,
              )
              .then(() => {
                  this.loadingModal(false);
              })
              .catch(error => {
                  this.handleError(error, this.errors);
              });
            }
        }
      },
      cancel() {
        this.hideModal({});
      },

      async fetchPermission(forcePage) {
        const { page, itemsPerPage } = this.pagination;
        return permissionsService.index({
          page: page || forcePage || 1,
          itemsPerPage,
          filters: this.requestFilters,
        })
        .then(response => {
            this.items = response.data.data;
            this.totalItems = response.data.meta.total;
            this.pagination = this.getPagination(
              response.data.meta,
              { oldPagination: this.pagination, forcePage },
            );
        })
        .catch(error => {
            this.handleError(error, this.errors);
        })
        .finally(() => {
          this.loading = false;
        });
      },

      async fetchRole(id) {
        return rolesService.get(id)
        .then(response => {
            this.role = response.data.data;
        })
        .catch(error => {
            this.handleError(error, this.errors);
        });
      },

      async fetchRolePermissions(id) {
        return rolesService.getPermissions(id)
        .then(response => {
            this.selected = response.data.data;
        })
        .catch(error => {
            this.handleError(error, this.errors);
        });
      },
    },

    async created() {
      this.loadingModal(true);
      await this.fetchPermission();
      if (this.data.stored.id) {
        await this.fetchRole(this.data.stored.id);
        await this.fetchRolePermissions(this.role.id);
        this.form = {
          id: this.data.stored.id,
          name: this.role.name,
          permission: this.selected,
        };
      }
      this.loadingModal(false);
    },
  };
</script>
